export default {
  UploadAPI: 'UploadApi',
};
